/******************************************** STYLING *********************************************/
const s = require(`./cookie-consent.scss`);

/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import {observer, inject} from 'mobx-react';
import cn from 'classnames';

/**************************************** PROJECT MODULES *****************************************/
import {CookieConsentBarViewProps} from './cookie-consent-bar-container';
import {translate, onEnterPress} from '@canimmunize/core-imports';

/********************************************* EXPORT *********************************************/
/**
 * Cookie consent bar UI
 */
export const CookieConsentBarView = inject('config')(
    observer(({hasConsented, animationEnd, setConsented, config}: CookieConsentBarViewProps) => (
        <div
            role="dialog"
            aria-live="polite"
            aria-label="cookieconsent"
            aria-describedby="cookieconsent:desc"
            style={{
                color: `rgb(255, 255, 255)`,
                backgroundColor: `rgb(37, 46, 57)`,
                ...(animationEnd && {display: 'none'}),
            }}
            className={cn(
                s[`cc-window`],
                s[`cc-banner`],
                s[`cc-top`],
                hasConsented ? s[`cc-invisible`] : ``
            )}
        >
            <span id="cookieconsent:desc" className={cn(s[`cc-message`])}>
                {translate(`cookies_used`)}
                <a
                    aria-label={translate(`consent_cookies`)}
                    role="button"
                    tabIndex={0}
                    className={cn(s[`cc-link`])}
                    href={config.urls.canimmunizeWeb.cookiePolicy}
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                >
                    {translate(`learn_more`)}
                </a>
            </span>
            <div className={cn(s[`cc-compliance`])}>
                <a
                    aria-label="dismiss cookie message"
                    role="button"
                    tabIndex={0}
                    className={cn(s[`cc-btn`])}
                    onClick={setConsented}
                    onKeyUp={onEnterPress(setConsented)}
                >
                    {translate(`okay`)}
                </a>
            </div>
        </div>
    ))
);

CookieConsentBarView.displayName = `CookieConsentBarView`;
